const getFacilityEmail = ({ facility, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (facility && facility['Company Contact'] && facility['Company Contact'].ID) {
    return facility['Company Contact'].Email;
  }
  return null;
};

export default getFacilityEmail;



// WEBPACK FOOTER //
// ./src/utils/print/getFacilityEmail.js